import { useEffect, useRef, useState, useCallback } from "react";
import { IoMdDownload } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useSearchParams, useLocation,useNavigate } from "react-router-dom";

import FirstReport from "./FirstReport";
import SecondReport from "./SecondReport";
import ThirdReport from "./ThirdReport";
import FourthReport from "./FourthReport";
import FifthReport from "./FifthReport";
import SixthReport from "./SixthReport";
import SeventhReport from "./SeventhReport";
import EighthReport from "./EighthReport";
import NinthReport from "./NinthReport";
import TenthReport from "./TenthReport";
import EleventhReport from "./EleventhReport";
import TwelfthReport from "./TwelfthReport";
import ThirteenthReport from "./ThirteenthReport";
import FourteenthReport from "./FourteenthReport";
import ReportRadarChart from "../IdeaValidationReport/ReportRadarChart";
import ReportAIInsights from "../IdeaValidationReport/ReportAIInsights";
import ReportSecondSection from "../IdeaValidationReport/ReportSecondSection";

import "./Report-B.css";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const ReportB = ({ hideUI = false, setToggle, onClose }) => {
  const sectionRefs = useRef([]);
  const partA = crypto.randomUUID() + crypto.randomUUID();
              const partB = crypto.randomUUID() + crypto.randomUUID();
             
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate=useNavigate()

  // UI navigation
  const stateReport = location.state?.reportData || null;

  // PDF / Puppeteer
  const pdfUserId = searchParams.get("userId");
  const pdfReportId = searchParams.get("reportId");

  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  if (isMobile) {
    localStorage.setItem("fromMobileReports", "true");
  }

  return () => {
    localStorage.removeItem("fromMobileReports");
  };
}, []);


  /* ------------------------------------
     FETCH REPORT BY ID (PDF MODE)
  -------------------------------------*/
  const fetchReportById = useCallback(async (userId, reportId) => {
    try {
      const res = await fetch(
        `${BACKEND}/idea-validation/report-list/${userId}`,
        { credentials: "include" }
      );

      if (!res.ok) throw new Error("Failed to fetch reports");

      const data = await res.json();

      if (!data.success || !data.reports?.length) {
        throw new Error("No reports found");
      }

      const match = data.reports.find(
        (r) => String(r.id) === String(reportId)
      );

      if (!match) throw new Error("Report not found");

      return match;
    } catch (err) {
      console.error("❌ Error fetching report by ID:", err);
      return null;
    }
  }, []);

  /* ------------------------------------
     LOAD DATA
  -------------------------------------*/
  useEffect(() => {
    const load = async () => {
      try {
        // 1️⃣ UI FLOW
        if (stateReport) {
          setReportData(stateReport);
          return;
        }

        // 2️⃣ PDF FLOW
        if (pdfUserId && pdfReportId) {
          const report = await fetchReportById(
            pdfUserId,
            pdfReportId
          );
          setReportData(report);
          return;
        }

        throw new Error("No report source available");
      } catch (err) {
        console.error("❌ Report load failed:", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [stateReport, pdfUserId, pdfReportId, fetchReportById]);

  /* ------------------------------------
     PDF DOWNLOAD (UI ONLY)
  -------------------------------------*/
  const downloadReport = async () => {
    try {
      setToggle(false);
      onClose();
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = 210;
      const pdfHeight = 297;

      const topMargin = 15;
      const bottomMargin = 15;
      const usableHeight = pdfHeight - topMargin - bottomMargin;

      let yOffset = topMargin;

      for (let i = 0; i < sectionRefs.current.length; i++) {
        const section = sectionRefs.current[i];
        if (!section) continue;

        const canvas = await html2canvas(section, {
          scale: 2,
          useCORS: true,
          backgroundColor: "#FFFFFF",
        });

        const imgData = canvas.toDataURL("image/png");
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;

        if (yOffset + imgHeight > topMargin + usableHeight) {
          pdf.addPage();
          yOffset = topMargin;
        }

        pdf.addImage(imgData, "PNG", 0, yOffset, pdfWidth, imgHeight);
        yOffset += imgHeight + 5;
      }

      pdf.save("Idea Validation Report_A+ by Marsmate AI.pdf");
    } catch (error) {
      console.error("PDF download error:", error);
      alert("download feature is coming soon");
    }
  };

  /* ------------------------------------
     GUARDS
  -------------------------------------*/
  if (loading) return <div style={{ padding: 40 }}>Loading report…</div>;

  if (!reportData) {
    return (
      <div style={{ padding: 40, color: "red" }}>
        Failed to load report data
      </div>
    );
  }

  /* ------------------------------------
     RENDER
  -------------------------------------*/
  return (
    <div className="report-page-mind">
      {!hideUI && (
        <div className="download-container-rb">
           <button
  className="back-btn-report"
  onClick={() => {
    const fromMobile = localStorage.getItem("fromMobileReports");
    localStorage.removeItem("fromMobileReports");
    onClose();
    setToggle(false);
    if (fromMobile === "true") {
      navigate(`/mobile/reports/${partA}/${partB}`);
    } else {
      navigate(-1);
    }
  }}
>
  <FaArrowLeftLong size={26} />
</button>

          <button className="download-btn" onClick={downloadReport}>
            Download <IoMdDownload size={26} />
          </button>
        </div>
      )}

      <div className="report-section">
        {[
          FirstReport,
          ReportSecondSection,
          ReportRadarChart,
          ReportAIInsights,
          SecondReport,
          ThirdReport,
          FourthReport,
          FifthReport,
          SixthReport,
          SeventhReport,
          EighthReport,
          NinthReport,
          TenthReport,
          EleventhReport,
          TwelfthReport,
          ThirteenthReport,
          FourteenthReport,
        ].map((Component, index) => (
          <div key={index} className="pdf-section">
            <Component res={reportData} extended={Component === ReportAIInsights} />
            {index === 0 && <hr className="hr2" />}
          </div>
        ))}
      </div>

      <div className="pdf-only">
        {[
          FirstReport,
          ReportSecondSection,
          ReportRadarChart,
          ReportAIInsights,
          SecondReport,
          ThirdReport,
          FourthReport,
          FifthReport,
          SixthReport,
          SeventhReport,
          EighthReport,
          NinthReport,
          TenthReport,
          EleventhReport,
          TwelfthReport,
          ThirteenthReport,
          FourteenthReport,
        ].map((Component, index) => (
          <div
            key={index}
            ref={(el) => (sectionRefs.current[index] = el)}
            className="pdf-section"
          >
            <Component res={reportData} extended={Component === ReportAIInsights} />
            {index === 0 && <hr className="hr2" />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportB;
